export default new class Time {
    constructor() {
        this.time = '.time';
        this.timeSelect = '.js-timeSelect';
        this.hoursSelect = '.js-timeHours';
        this.minutesSelect = '.js-timeMinutes';
        this.timeSelectedClass = '_timeSelected';
        this.timeInput = 'js-timeInput';

        this.cartItem = '.cart-item';
        this.cartForm = '.cart-contact';

        this.init();
    }

    init() {
        if (!$(this.time).length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        //remove placeholder
        $(document).on('change', this.timeSelect, (e) => {
            //removes placeholder text from selects options (the placeholder text should has data attr 'data-type=placeholder')
            let $placeholder = $(e.target).find('option[data-type="placeholder"]'),
                $cartItem = $(e.target).closest(this.cartItem);

            $placeholder.remove();
            $(e.target).addClass(this.timeSelectedClass);
            $(e.target).niceSelect('update');

            // add hidden inputs with selected time and offer id in cart form
            this.appendSelectedTimeToForm($cartItem);
        });
    }

    /**
     * Append to cart form hidden input with offer-id and selected time to pick up
     *
     * @param $cartItem - jquery obj, current cart item
     */
    appendSelectedTimeToForm($cartItem) {
        let cartItemId = $cartItem.attr('data-offer-id'),
            $timeBlock =  $cartItem.find(this.time),
            $hoursSelect = $timeBlock.find(`select${this.hoursSelect}`),
            $minutesSelect = $timeBlock.find(`select${this.minutesSelect}`);

        if (this.isTimeSelected($timeBlock)) {
            let hours = $hoursSelect.val(),
                minutes = $minutesSelect.val(),
                $alreadyAddedTimeInput = $(this.cartForm).find(`.${this.timeInput}[name="offer[${cartItemId}]"]`); //input witch already added for current cart-item

            if ($alreadyAddedTimeInput.length) {
                //change value of input if its already added to the form
                $alreadyAddedTimeInput.val(`${hours}:${minutes}`);
            } else {
                //append input in cart form with time and offer details
                $(this.cartForm).append(`<input class="${this.timeInput}" type="hidden" name="offer[${cartItemId}]" value="${hours}:${minutes}">`);
            }
        }
    }

    /**
     * Detect is time was selected in all selects in current time block
     *
     * @param $timeBlock - jquery obj of time block with time selectcs
     * @returns {boolean} - is time selected in all selects in time block
     */
    isTimeSelected($timeBlock) {
        let isSelected = true,
            $timeSelects = $timeBlock.find(`select${this.timeSelect}`);

        for(let i = 0; i <$timeSelects.length; i++) {
            if (!($($timeSelects[i]).hasClass(this.timeSelectedClass))) {
                isSelected = false;
            }
        }

        return isSelected;
    }

    /**
     * Delete time input
     *
     * @param $cartItem - jquery obj
     */
    deleteTimeInput ($cartItem) {
        let cartItemId = $cartItem.attr('data-offer-id'),
            $currentInput = $(this.cartForm).find(`.${this.timeInput}[name="offer[${cartItemId}]"]`);

        $currentInput.remove();
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/time/time.js